import { render, staticRenderFns } from "./UpdateSplash.vue?vue&type=template&id=1036b2f4&scoped=true&"
import script from "./UpdateSplash.vue?vue&type=script&lang=js&"
export * from "./UpdateSplash.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSplash.vue?vue&type=style&index=0&id=1036b2f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1036b2f4",
  null
  
)

export default component.exports